import $ from "jquery";

$("body").on("click tap", ".js_stop-propagation", function (e) {
    e.stopPropagation();
});
